module.exports = __webpack_public_path__ + "media/images/next-gen-blog-background-74e9c519255f382a40d703277053db16.jpg";